var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1667 4.49993C16.3856 4.28106 16.6454 4.10744 16.9314 3.98899C17.2173 3.87054 17.5238 3.80957 17.8334 3.80957C18.1429 3.80957 18.4494 3.87054 18.7353 3.98899C19.0213 4.10744 19.2812 4.28106 19.5 4.49993C19.7189 4.7188 19.8925 4.97863 20.011 5.2646C20.1294 5.55057 20.1904 5.85706 20.1904 6.16659C20.1904 6.47612 20.1294 6.78262 20.011 7.06859C19.8925 7.35455 19.7189 7.61439 19.5 7.83326L8.25002 19.0833L3.66669 20.3333L4.91669 15.7499L16.1667 4.49993Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.7e22a0b21b9d45075d88b22e71a07bac.svg";
export { ForwardRef as ReactComponent };